import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { useAdminAuth } from '@/context/AdminAuthContext';

export function AdminProtectedRoute() {
  const { isAuthenticated } = useAdminAuth();
  if (!isAuthenticated) return <Navigate to={ROUTES.adminLogin} replace />;
  return <Outlet />;
}

export function AdminPublicRoute() {
  const { isAuthenticated } = useAdminAuth();
  if (isAuthenticated) return <Navigate to={ROUTES.adminRoot} replace />;
  return <Outlet />;
}
